<div [ngClass]="{'icc-inplace icc-component': true, 'icc-inplace-closable': closable}" [ngStyle]="style" [class]="styleClass">
    <div class="icc-inplace-display" (click)="onActivateClick($event)" tabindex="0" (keydown)="onKeydown($event)"
        [ngClass]="{'icc-disabled':disabled}" *ngIf="!active">
        <ng-content select="[iccInplaceDisplay]"></ng-content>
        <ng-container *ngTemplateOutlet="displayTemplate"></ng-container>
    </div>
    <div class="icc-inplace-content" *ngIf="active">
        <ng-content select="[iccInplaceContent]"></ng-content>
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        <button type="button" title="Close" iccIconButton (click)="onDeactivateClick($event)" *ngIf="closable">
            <icc-icon [name]="closeIcon"></icc-icon>
        </button>
    </div>
</div>